import React from 'react';
import { Box, Skeleton } from '@mui/material';

const TimelineSkeleton = ({ count = 5, dateWidth = 200 }) => {
  return (
    <Box>
      {Array.from({ length: count }).map((_, index) => (
        <Box key={index} sx={{ display: 'flex', mb: 3 }}>
          <Box sx={{ width: `${dateWidth}px`, pr: 2, pt: 1 }}>
            <Box sx={{ textAlign: 'right' }}>
              <Skeleton
                variant='text'
                width='80%'
                height={20}
                sx={{ display: 'inline-block' }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              px: 2,
            }}>
            <Skeleton
              variant='circular'
              width={24}
              height={24}
              sx={{ mb: 1 }}
            />
            {index < count - 1 && (
              <Box
                sx={{
                  width: 2,
                  height: 60,
                  bgcolor: 'divider',
                  mb: 2,
                }}
              />
            )}
          </Box>

          <Box sx={{ flex: 1, minWidth: 0, py: 1 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                mb: 0.5,
              }}>
              <Skeleton variant='text' width='40%' height={24} />
              <Skeleton
                variant='rectangular'
                width={80}
                height={24}
                sx={{ borderRadius: 1 }}
              />
            </Box>

            <Skeleton variant='text' width='90%' height={20} sx={{ mb: 0.5 }} />
            <Skeleton variant='text' width='70%' height={20} sx={{ mb: 1 }} />

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
              <Skeleton variant='text' width='30%' height={16} />
              <Skeleton
                variant='rectangular'
                width={90}
                height={24}
                sx={{ borderRadius: '12px' }}
              />
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default TimelineSkeleton;
